type IconProps = { className?: string };

export function LaposteBrandIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <rect width="24" height="24" rx="6" fill="#003DA5" />
      <path fill="#FFCC00" d="M4 14h16v3H4z" />
      <path fill="#fff" d="M7 8.5h10v3H7z" />
    </svg>
  );
}
